var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 8.85625C6.16875 8.85625 5.08125 7.775 5.08125 6.4375C5.08125 5.1 6.16875 4.025 7.5 4.025C8.83125 4.025 9.91875 5.10625 9.91875 6.44375C9.91875 7.78125 8.83125 8.85625 7.5 8.85625ZM7.5 4.9625C6.6875 4.9625 6.01875 5.625 6.01875 6.44375C6.01875 7.2625 6.68125 7.925 7.5 7.925C8.31875 7.925 8.98125 7.2625 8.98125 6.44375C8.98125 5.625 8.3125 4.9625 7.5 4.9625Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 14.225C6.575 14.225 5.64375 13.875 4.91875 13.1813C3.075 11.4063 1.0375 8.575 1.80625 5.20625C2.5 2.15 5.16875 0.78125 7.5 0.78125C7.5 0.78125 7.5 0.78125 7.50625 0.78125C9.8375 0.78125 12.5063 2.15 13.2 5.2125C13.9625 8.58125 11.925 11.4063 10.0812 13.1813C9.35625 13.875 8.425 14.225 7.5 14.225ZM7.5 1.71875C5.68125 1.71875 3.34375 2.6875 2.725 5.4125C2.05 8.35625 3.9 10.8938 5.575 12.5C6.65625 13.5437 8.35 13.5437 9.43125 12.5C11.1 10.8938 12.95 8.35625 12.2875 5.4125C11.6625 2.6875 9.31875 1.71875 7.5 1.71875Z",
    fill: "#6E6E6E",
    stroke: "#6E6E6E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGreen);
export default __webpack_public_path__ + "static/media/location-green.bca659843e7de52503087966fcf9afad.svg";
export { ForwardRef as ReactComponent };